export default "__VITE_ASSET__BULIhwbG__"